import React from 'react'

import { bottles } from 'src/axious/bottles'
import { BottleType } from 'src/pages/Bottle/Bottles.types'
import { handleAxiosError } from 'src/utils/errorHandling'

export const useGetBottleById = (id: string, bottlePage: boolean = false, styles?: any, isActiveLoading?: boolean) => {
  const [bottleData, setBottleData] = React.useState<BottleType>()
  let background: string

  React.useEffect(() => {
    const getDataAboutBottle = async () => {
      try {
        const res = await bottles('get', `/${id}`)
        setBottleData(res)

        if (bottlePage) {
          // background = res.type !== 'FIXED' ? 'orange-background' : 'green-background'
          background = 'blue-background'
          document.body.classList.add(styles[background])
        }
      } catch (err) {
        const errorMessage = handleAxiosError(err)
        console.log(errorMessage)
      }
    }

    getDataAboutBottle()

    return () => {
      if (bottlePage) {
        document.body.classList.remove(styles[background])
      }
    }
  }, [id, setBottleData, isActiveLoading])

  return { bottleData }
}
